export default __webpack_public_path__ + "static/media/bit-greet.3251fb1d.svg";